import { apiWrapper } from "@/services/api";

export const putRestore = async (id) => {
  try {
    // リクエストはtrueで固定
    const apiParams = true;

    await apiWrapper("PUT", `books/${id}/is_restored`, apiParams);
  } catch (err) {
    console.log('ERROR"" putRestore()');
    throw err;
  }
};
